import React from "react";
import styles from "./Template.module.scss";
import quotes from "./../assets/png/quotes.png";
import chairman from "../assets/chairman.jpg";

const Testimonial = () => {
  return (
    <div className={styles.banner}>
      <div className={styles.container}>
        <img src={quotes} alt="quotes" />
        <div className={styles.content}>
          <strong className={styles.big_text_54}>
            Grateful for your <br /> dedication; together, we'll <br /> conquer
            new logistics <br />
            horizons.
          </strong>
        </div>
        <div className={styles.profile_card}>
          <div className={styles.circle}>
            <img src={chairman} alt="chairman" />
          </div>
          <div className={styles.name_card}>
                <div className={styles.name}>Shekhar Chaki</div>
                <label className={styles.nameLabel}>Managing Director</label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
